import { cn } from "../../lib/utils";


interface TitleProps extends React.HTMLAttributes<HTMLHeadingElement> {
  children: React.ReactNode;
}

export const H1 = ({ children, className, ...props }: TitleProps) => {
	return <h1 className={cn("text-3xl font-semibold text-text-main-blue mb-3", className)} {...props}>{children}</h1>;
};

export const H2 = ({ children, className, ...props }: TitleProps) => {
	return (
		<h2 className={cn("text-xl font-semibold text-text-main-blue mb-3", className)} {...props}>{children}</h2>
	);
};

export const H3 = ({ children, className, ...props }: TitleProps) => {
	return <h3 className={cn("text-base text-text-main-blue mb-3", className)} {...props}>{children}</h3>;
};